export const CLIENT_ID = 'f4323c6f7c0cd73d2d786a2b1cdae80c';
export const MAP_API_KEY = 'AIzaSyDHgBKhbpf43KlsthHUHpl8vK_gN0JskJ0';

export const domain = 'nedvx';

export const ROOT_URL = `https://testapi.nedvex.ru`;
export const ROOT_URL_AUTH = `https://prodapp.${domain}.net`;
  // ~location.origin.indexOf('portaldev') ?
  // 'http://devapp.nedvex.net:84' :
  // 'https://prodapp.nedvex.net'

export const CDN = `https://${domain}.ru/cdn`;

// Hardcoded panormas for a while
export const ROOM_LIST = {
  '11-46': 0,
  '2-66': 1,
  '3-68': 3,
  '4-40.1': 4,
  '5-32': 5,
  '6-36.7': 6,
  '7-38': 7,
  '8-44.1': 8,
  '9-44.1': 9,
  '11-61.1': 10,
  '12-43.7': 11,
  '4-34.8': 12,
  '5-34.8': 13,
  '6-31.3': 14,
  '7-31.3': 15,
  '8-32.6': 16
};



// WEBPACK FOOTER //
// ./src/constants/Config.js